/*
  PRE-ORDER LINE PROPERTY -- REMOVER (2026-09-29).

  This file used to STAMP "Estimated dispatch: Ships <window>" onto every
  pre-order cart line, and label Kaching's upsell cards "Pre-order -- ships ...".
  Gabe, 2026-09-29: drop the pre-order highlight from the cart and checkout; the
  only mention left is the muted line under Add to cart on the PDP
  (snippets/ef-pdp-preorder-note.liquid).

  The asset key is kept (theme.liquid loads it, and cached pages reference it --
  see storefront-cache rule: never delete an asset a cached page may request).
  It now does the reverse: strips "Estimated dispatch" from any cart line that
  still carries it (carts built before this change), so it never reaches the
  cart drawer or checkout.

  Rules kept from the old stamper, because /cart/change.js REPLACES the property
  set and treats an omitted quantity as 1:
    - merge the other properties back in (`_kaching_cart` carries the discount);
    - always send the line's quantity.
*/
(function () {
  if (window.__efPreorderStamp) return;
  window.__efPreorderStamp = true;

  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var PROP = 'Estimated dispatch';
  var MAX_PASSES = 6;
  var busy = false;

  function cart() {
    return fetch(ROOT + 'cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .catch(function () { return null; });
  }

  // One line per pass: change.js mints a new key for the line it edits.
  function pass(n) {
    if (n >= MAX_PASSES) return Promise.resolve();
    return cart().then(function (c) {
      if (!c || !c.items) return;
      var target = null;
      for (var i = 0; i < c.items.length; i++) {
        var p = c.items[i].properties;
        if (p && Object.prototype.hasOwnProperty.call(p, PROP)) { target = c.items[i]; break; }
      }
      if (!target) return;
      var props = {};
      Object.keys(target.properties).forEach(function (k) {
        if (k !== PROP) props[k] = target.properties[k];
      });
      // An empty set is not treated as "replace with nothing", so a line whose
      // only property was the date keeps it. A hidden `_` key forces the
      // replace; underscore properties never show in the cart or at checkout.
      // (Verified 2026-09-29: sending the other keys without PROP drops PROP.)
      if (!Object.keys(props).length) props._ef = '1';
      return fetch(ROOT + 'cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify({ id: target.key, quantity: target.quantity, properties: props }),
      })
        .then(function () { return pass(n + 1); })
        .catch(function () {});
    });
  }

  function run() {
    if (busy) return;
    busy = true;
    pass(0)
      .catch(function () {})
      .then(function () {
        busy = false;
        document.querySelectorAll('.ef-preorder-offer-note').forEach(function (n) { n.remove(); });
      });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();
